const addTagsCustomer = async ({id, tags}) => {
  try {
    const response = await fetch('/api/add-tags-customer', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id,
        tags
      })
    });

    return response.json();
  } catch (error) {
    console.log(error);
  }
};

export default addTagsCustomer;
